{
  "common": {
    "cancel": "Peruuta"
  },
  "footer": {
    "terms": "Käyttöehdot"
  },
  "nav": {
    "dashboard": "Yhteenveto",
    "sessions": "Lataushistoria",
    "contracts": "Sopimukset",
    "subUsers": "Lisäkäyttäjät",
    "admin": "Hallinta",
    "guide": "Ohjeet",
    "logout": "Kirjaudu ulos",
    "menu": "Valikko"
  },
  "login": {
    "title": "Latausportaali",
    "identifier": "Sähköpostiosoite",
    "placeholder": "etunimi@email.fi",
    "userNotFound": "Sähköpostiosoitetta ei löydy järjestelmästä. Rekisteröidy ensin.",
    "sendCode": "Lähetä koodi",
    "sending": "Lähetetään…",
    "otpPrompt": "Syötä 6-numeroinen koodi joka lähetettiin osoitteeseen",
    "codeExpires": "Koodi vanhenee:",
    "verify": "Kirjaudu sisään",
    "verifying": "Tarkistetaan…",
    "changeOrResend": "← Vaihda osoite tai pyydä uusi koodi",
    "noAccount": "Ei tiliä?",
    "register": "Rekisteröidy",
    "magicLinkExpired": "Kirjautumislinkki on vanhentunut tai jo käytetty. Kirjaudu sähköpostiosoitteellasi.",
    "accountNotActive": "Tilisi ei ole vielä aktiivinen.",
    "guide": "Latausohjeet"
  },
  "register": {
    "title": "Rekisteröidy",
    "name": "Nimi",
    "email": "Sähköpostiosoite",
    "phone": "Puhelinnumero (kansainvälinen muoto, esim. +358401234567)",
    "apartment": "Huoneistonumero",
    "registrationKey": "Rekisteröintiavain",
    "registrationKeyPlaceholder": "Syötä taloyhtiön rekisteröintiavain",
    "termsAccept": "Olen lukenut ja hyväksyn",
    "termsLink": "lataussopimuksen käyttöehdot",
    "submit": "Jatka",
    "submitting": "Lähetetään vahvistuskoodia...",
    "hasAccount": "Onko sinulla jo tili?",
    "login": "Kirjaudu",
    "verifyTitle": "Vahvista sähköpostisi",
    "otpSent": "Lähetimme 6-numeroisen koodin osoitteeseen",
    "backToForm": "← Takaisin lomakkeelle",
    "successTitle": "Rekisteröityminen vastaanotettu",
    "successMessage": "Isännöitsijä tarkistaa tietosi ja aktivoi tilisi. Saat ilmoituksen sähköpostitse.",
    "backToLogin": "← Takaisin kirjautumiseen",
    "parkingSpace": "Autopaikan numero",
    "parkingSpacePlaceholder": "Esim. 12"
  },
  "validation": {
    "invalidEmail": "Virheellinen sähköpostiosoite",
    "phoneTooShort": "Puhelinnumero on liian lyhyt",
    "nameTooShort": "Nimi on liian lyhyt",
    "apartmentRequired": "Huoneistonumero vaaditaan",
    "registrationKeyRequired": "Rekisteröintiavain vaaditaan",
    "termsRequired": "Käyttöehdot on hyväksyttävä",
    "invalidRegistrationKey": "Virheellinen rekisteröintiavain."
  },
  "errors": {
    "generic": "Jokin meni pieleen. Yritä uudelleen.",
    "wrongCode": "Väärä koodi. Yritä uudelleen.",
    "wrongVerificationCode": "Väärä vahvistuskoodi. Tarkista sähköpostisi.",
    "tooManyAttempts": "Liian monta yritystä. Pyydä uusi koodi.",
    "tooManyRequests": "Liian monta pyyntöä. Odota hetki ennen uutta yritystä.",
    "expired": "Koodi vanheni. Pyydä uusi.",
    "expiredReturn": "Koodi vanheni. Palaa takaisin ja yritä uudelleen.",
    "emailAlreadyRegistered": "Sähköpostiosoite on jo rekisteröity. Kirjaudu sisään.",
    "registrationFailed": "Rekisteröinti epäonnistui.",
    "otpSendFailed": "Vahvistuskoodin lähetys epäonnistui. Yritä uudelleen.",
    "accountNotActive": "Tilisi ei ole vielä aktivoitu. Isännöitsijä aktivoi tilin rekisteröitymisen jälkeen."
  },
  "dashboard": {
    "loading": "Ladataan...",
    "sessionsCount": "Latauksia",
    "energy": "Energia",
    "spotCost": "Spot-energia",
    "marginCost": "Marginaali",
    "cost": "Yhteensä",
    "spotLabel": "spot",
    "marginLabel": "marginaali",
    "energyChart": "Kuukausittainen kulutus",
    "costChart": "Kuukausittaiset kustannukset",
    "apartment": "Huoneisto",
    "phone": "Puhelin",
    "parking": "Autopaikka",
    "estimatedWarning": "Osa hinnoista on arvioita (spot-hintoja ei ollut saatavilla laskentahetkellä).",
    "monthlyChart": "Kuukausittainen kulutus (kWh)",
    "chartTooltip": "Energia",
    "recentSessions": "Viimeisimmät lataukset",
    "noSessions": "Ei lataussessioita vielä.",
    "showAll": "Näytä kaikki lataukset →"
  },
  "sessions": {
    "loading": "Ladataan...",
    "noSessions": "Ei lataussessioita vielä.",
    "estimated": "arvio",
    "loadingIntervals": "Ladataan erittelyä...",
    "noIntervals": "Erittelyä ei saatavilla.",
    "time": "Aika",
    "kwh": "kWh",
    "spot": "Spot",
    "margin": "Marginaali",
    "price": "Hinta",
    "startTime": "Lataus alkoi",
    "endTime": "Lataus päättyi",
    "charger": "Latauslaite",
    "activatedWith": "Aktivoitu",
    "zaptecApp": "Zaptec-sovellus",
    "totalEnergy": "Energia",
    "energyCost": "Energiamaksu (spot)",
    "marginCost": "Marginaali",
    "totalCost": "Yhteensä",
    "spotLabel": "spot",
    "marginLabel": "marginaali",
    "sessionCount": "latausta",
    "presetCurMonth": "Kuluva kk",
    "presetPrevMonth": "Edellinen kk",
    "presetCurQuarter": "Kuluva kvartaali",
    "presetPrevQuarter": "Edellinen kvartaali",
    "presetLast30": "30 päivää",
    "presetAll": "Kaikki",
    "exportTitle": "Lataushistoria",
    "print": "Tulosta / tallenna PDF"
  },
  "contracts": {
    "title": "Sopimukset",
    "loading": "Ladataan...",
    "noContracts": "Ei sopimuksia.",
    "primary": "Pääsopimus",
    "sub": "Alasopimus",
    "parking": "Autopaikka",
    "startDate": "Alkupäivä",
    "endDate": "Päättymispäivä",
    "active": "Aktiivinen",
    "ended": "Päättynyt",
    "end": "Päätä sopimus",
    "endConfirm": "Sopimus päättyy {{endDate}}. Haluatko jatkaa?",
    "ended_success": "Sopimus päätetty",
    "description": "Lataustapahtumat kohdistuvat pääsopimukselle. Alasopimus on sitä varten, jos käyttäjällä on useampi autopaikka tai ajoneuvo joita lataa.",
    "subUsers": "Lisäkäyttäjät",
    "addSubUser": "Lisää lisäkäyttäjä",
    "subUserName": "Nimi",
    "subUserEmail": "Sähköposti",
    "removeSubUser": "Poista",
    "removeConfirm": "Haluatko poistaa lisäkäyttäjän?",
    "subUserAdded": "Lisäkäyttäjäpyyntö lähetetty",
    "subUserRemoved": "Lisäkäyttäjä poistettu",
    "pendingApproval": "Odottaa hyväksyntää",
    "requestNew": "Lisää uusi alasopimus",
    "requestPrimary": "Tee uusi sopimus",
    "noPrimaryInfo": "Sinulla ei ole voimassa olevaa pääsopimusta. Voit pyytää uutta sopimusta isännöitsijältä.",
    "requestSent": "Sopimuspyyntö lähetetty",
    "requestParking": "Autopaikan numero",
    "requestApartment": "Huoneisto"
  },
  "subUsers": {
    "title": "Lisäkäyttäjät",
    "description": "Lisäkäyttäjälle luodaan Zaptec-kirjautuminen ja latausoikeus. Lisäkäyttäjä ei voi kirjautua tähän latausportaaliin. Lisäkäyttäjien latausten laskutus kohdistuu pääkäyttäjään jonka alla lisäkäyttäjä on.",
    "loading": "Ladataan...",
    "noSubUsers": "Ei lisäkäyttäjiä.",
    "add": "Lisää lisäkäyttäjä",
    "edit": "Muokkaa",
    "name": "Nimi",
    "email": "Sähköposti",
    "phone": "Puhelin",
    "status": "Tila",
    "activate": "Aktivoi",
    "deactivate": "Poista käytöstä",
    "added": "Lisäkäyttäjä lisätty",
    "updated": "Lisäkäyttäjän tiedot päivitetty",
    "removed": "Lisäkäyttäjä poistettu käytöstä",
    "reactivated": "Lisäkäyttäjä aktivoitu uudelleen"
  },
  "admin": {
    "title": "Hallinta",
    "tabs": {
      "users": "Käyttäjät",
      "contracts": "Sopimukset",
      "sessions": "Lataukset",
      "pricing": "Hinnoittelu",
      "settings": "Asetukset",
      "parking": "Autopaikat",
      "stats": "Tilastot",
      "reports": "Raportit",
      "auditLog": "Tapahtumaloki",
      "system": "Järjestelmä",
      "releasenotes": "Releasenotes"
    },
    "releasenotes": {
      "title": "Versiopäivitykset",
      "empty": "Ei vielä release noteja",
      "new": "Uusi release note",
      "newTitle": "Lisää release note",
      "editTitle": "Muokkaa release notea",
      "version": "Versio (esim. v1.2.3)",
      "releaseDate": "Julkaisupäivä",
      "titleLabel": "Otsikko (vapaaehtoinen)",
      "titlePlaceholder": "Lyhyt kuvaus",
      "body": "Sisältö",
      "save": "Tallenna",
      "edit": "Muokkaa",
      "delete": "Poista",
      "deleted": "Release note poistettu",
      "saved": "Release note tallennettu",
      "confirmDelete": "Poistetaanko {{version}}?",
      "releases": "julkaisua"
    },
    "users": {
      "pendingTitle": "Odottaa aktivointia",
      "activate": "Aktivoi",
      "activeTitle": "Aktiiviset käyttäjät",
      "name": "Nimi",
      "email": "Sähköposti",
      "apartment": "Huoneisto",
      "roles": "Roolit",
      "roleUser": "käyttäjä",
      "roleAdmin": "admin",
      "edit": "Muokkaa",
      "save": "Tallenna",
      "cancel": "Peruuta",
      "phone": "Puhelin",
      "status": "Tila",
      "contractRole": "Sopimus",
      "primaryHolder": "Pääkäyttäjä",
      "subUserOf": "Lisäkäyttäjä ·",
      "createUser": "Lisää käyttäjä",
      "createSubUser": "Lisää lisäkäyttäjä",
      "noPrimaryContract": "Käyttäjällä ei ole aktiivista pääsopimusta",
      "createContract": "Luo sopimus käyttäjälle",
      "userCreated": "Käyttäjä luotu",
      "newRegistration": "Uusi sopimus",
      "subUserRequest": "Lisäkäyttäjäpyyntö",
      "userSaved": "Käyttäjän tiedot päivitetty",
      "searchPlaceholder": "Hae nimellä, sähköpostilla, huoneistolla...",
      "placeholderDashIfNone": "merkitse \"-\" jos ei tiedossa",
      "errorNameRequired": "Nimi on pakollinen",
      "errorApartmentRequired": "Huoneistonumero on pakollinen (käytä \"-\" jos ei tiedossa)",
      "errorPhoneRequired": "Puhelinnumero on pakollinen (käytä \"-\" jos ei tiedossa)"
    },
    "contracts": {
      "activeTitle": "Aktiiviset sopimukset",
      "subContract": "Alasopimus",
      "primaryContract": "Pääsopimus",
      "apartment": "Huoneisto",
      "startDate": "Alkaen",
      "active": "aktiivinen",
      "endedTitle": "Päättyneet",
      "create": "Luo uusi sopimus",
      "user": "Käyttäjä",
      "parkingSpace": "Autopaikka",
      "end": "Päätä sopimus",
      "endConfirm": "Haluatko varmasti lakkauttaa tämän sopimuksen?",
      "created": "Sopimus luotu",
      "ended": "Sopimus lakkautettu",
      "edit": "Muokkaa sopimusta",
      "saved": "Sopimus päivitetty",
      "approve": "Hyväksy",
      "approved": "Sopimus hyväksytty"
    },
    "sessions": {
      "count": "sessiota",
      "time": "Aika",
      "device": "Laite",
      "kwh": "kWh",
      "price": "Hinta",
      "email": "Sähköposti",
      "token": "Tunniste",
      "estimatedPrice": "Arvioitu hinta",
      "unlinked": "kohdistamatta",
      "unlinkedTitle": "Kohdistamattomat lataukset",
      "reassignAll": "Kohdista tapahtumat",
      "reassignResult": "Kohdistettu: {{reassigned}}, epäonnistui: {{failed}}",
      "searchPlaceholder": "Hae nimellä, sähköpostilla tai tunnisteella…",
      "resync": "Hae uudelleen",
      "resyncFrom": "Alkaen",
      "resyncTo": "Päättyen",
      "resyncRun": "Hae ja laske",
      "resyncResult": "{{count}} uutta lataustapahtumaa haettu"
    },
    "settings": {
      "userMgmt": "Käyttäjähallinta",
      "magicLinkAdmin": "Kirjautumislinkin vastaanottaja",
      "magicLinkAdminAuto": "Automaattinen (ensimmäinen admin)",
      "magicLinkAdminHelp": "Tämä admin-käyttäjä saa sähköposteihin kertakäyttöisen kirjautumislinkin.",
      "recipients": "Kopiovastaanottajat (pilkulla erotetut)",
      "emailName": "Nimi sähköpostissa",
      "billing": "Laskutus",
      "billingRecipients": "Laskutusvastaanottajat",
      "reportCopies": "Raporttikopiot",
      "technicalAlerts": "Tekniset hälytykset",
      "operationalAlerts": "Operatiiviset hälytykset",
      "alertRecipients": "Vastaanottajat",
      "boardStats": "Hallituksen tilastoraportti",
      "boardStatsRecipients": "Vastaanottajat (pilkulla eroteltuna)",
      "boardStatsHelp": "Kuukausittain ensimmäisenä päivänä lähetettävä koonti tilastonäkymästä. Aikaväli: kuluva vuosi (tammikuussa edellinen vuosi).",
      "marginTitle": "Hintamarginaali",
      "defaultMargin": "Oletusmarginaali (snt/kWh)",
      "save": "Tallenna",
      "saving": "Tallennetaan...",
      "saved": "Tallennettu!",
      "saveFailed": "Tallennus epäonnistui"
    },
    "wizard": {
      "title": "Aktivoi käyttäjä ja luo sopimus",
      "userInfo": "Käyttäjän tiedot",
      "requestedParking": "Pyydetty autopaikka",
      "parkingValid": "Autopaikka vapaa",
      "parkingTaken": "Autopaikalla on jo sopimus",
      "parkingNotFound": "Autopaikkaa ei löydy järjestelmästä",
      "noParking": "Ei ilmoitettu",
      "configureContract": "Sopimuksen tiedot",
      "confirm": "Vahvista ja aktivoi",
      "activating": "Aktivoidaan...",
      "success": "Käyttäjä aktivoitu ja sopimus luotu",
      "reject": "Hylkää rekisteröinti",
      "rejectConfirm": "Haluatko hylätä tämän rekisteröinnin? Käyttäjä ei voi enää kirjautua.",
      "rejected": "Rekisteröinti hylätty"
    },
    "loading": "Ladataan...",
    "parking": {
      "title": "Autopaikat",
      "add": "Lisää autopaikka",
      "number": "Paikkanumero",
      "description": "Kuvaus",
      "user": "Käyttäjä",
      "status": "Tila",
      "free": "Vapaa",
      "created": "Autopaikka lisätty"
    },
    "templates": {
      "tab": "Sähköpostipohjat",
      "selectTemplate": "Valitse pohja",
      "paramsTitle": "Käytettävissä olevat muuttujat (kopioi viestiin sellaisenaan):",
      "subject": "Otsikko",
      "body": "Viestin sisältö",
      "saved": "Sähköpostipohja tallennettu!",
      "saveFailed": "Tallentaminen epäonnistui.",
      "sendTest": "Lähetä testi",
      "testEmailPlaceholder": "testi@email.fi",
      "testSent": "Testiviesti lähetetty!",
      "testFailed": "Testiviestin lähetys epäonnistui."
    },
    "stats": {
      "totalSessions": "Latauksia yhteensä",
      "totalEnergy": "Energia yhteensä",
      "spotEnergy": "Spot-energia",
      "billedEnergy": "Laskutettu energia",
      "spotLabel": "spot",
      "marginLabel": "marginaali",
      "usersBilled": "Laskutettu",
      "energyMargin": "Energian kate",
      "distribution": "siirto",
      "marginRevenue": "Marginaalitulot",
      "distributionCost": "Siirto + verot",
      "baseFee": "Perusmaksut",
      "costs": "kustannukset",
      "grossMargin": "Kate",
      "contracts": "Sopimukset",
      "contractRevenue": "Sopimustulot",
      "costBreakdown": "Taloyhtiön kustannusanalyysi",
      "month": "Kuukausi",
      "dateRange": "Aikaväli",
      "clearFilter": "Tyhjennä",
      "avgPrice": "Keskihinta",
      "presetPrevMonth": "Edellinen kk",
      "presetCurMonth": "Kuluva kk",
      "presetCurYear": "Kuluva vuosi",
      "presetPrevYear": "Edellinen vuosi",
      "presetAll": "Kaikki",
      "monthlyTrend": "Kuukausittainen kehitys",
      "chargerBreakdown": "Latauslaitekohtainen erittely",
      "utilization": "Käyttöaste",
      "charger": "Laite",
      "sessions": "Sessiot",
      "kwh": "kWh",
      "eur": "EUR"
    },
    "pricing": {
      "current": "Voimassa oleva hinnasto",
      "margin": "Latausmarginaali",
      "distribution": "Siirto + verot",
      "baseFee": "Perusmaksu",
      "inclVat": "sis. alv",
      "validFrom": "Voimassa alkaen",
      "upcoming": "Tuleva hinnasto",
      "history": "Hinnastohistoria",
      "add": "Lisää uusi hinnasto",
      "contractFee": "Sopimuksen kk-maksu",
      "saved": "Hinnasto tallennettu"
    },
    "reports": {
      "title": "Raportit",
      "quarter": "Kvartaali",
      "downloadCsv": "Lataa CSV",
      "downloadReport": "Lataa raportti",
      "preview": "Esikatselu",
      "user": "Käyttäjä",
      "apartment": "Huoneisto",
      "sessions": "Sessiot",
      "kwh": "kWh",
      "eur": "EUR",
      "parkingSpaces": "Autopaikat",
      "avgPrice": "Keskihinta",
      "total": "Yhteensä"
    },
    "subUsers": {
      "title": "Lisäkäyttäjät",
      "add": "Lisää lisäkäyttäjä",
      "activate": "Aktivoi",
      "name": "Nimi",
      "email": "Sähköposti",
      "status": "Tila",
      "added": "Lisäkäyttäjä lisätty",
      "activated": "Lisäkäyttäjä aktivoitu",
      "updated": "Lisäkäyttäjän tiedot päivitetty",
      "pending": "odottaa",
      "active": "aktiivinen",
      "inactive": "ei-aktiivinen"
    },
    "system": {
      "ok": "OK",
      "error": "Virhe",
      "incomplete": "Puutteellinen",
      "outdated": "Vanhentunut",
      "notConfigured": "Ei konfiguroitu",
      "lastSync": "Viimeisin synkronointi",
      "failures": "Epäonnistumisia",
      "spotPrices": "spot-hinnat",
      "today": "Tänään",
      "tomorrow": "Huomenna",
      "pricePoints": "hintapistettä",
      "backup": "Varmuuskopiointi",
      "lastBackup": "Viimeisin varmuuskopio",
      "files": "tiedostoa",
      "email": "Sähköposti",
      "sender": "Lähettäjä",
      "database": "Tietokanta",
      "rows": "riviä",
      "timers": "Ajastetut tehtävät",
      "timerName": "Tehtävä",
      "timerInterval": "Ajoväli",
      "timerAction": "Toiminto",
      "timerDisabled": "Ajastus pois käytöstä",
      "runNow": "Aja nyt",
      "runConfirm": "Ajetaanko \"{{name}}\" nyt?",
      "runSuccess": "{{name}} valmis ({{ms}} ms)",
      "runResult": "Tulos: {{name}} ({{ms}} ms)",
      "runResultDetails": "Näytä tarkemmat tiedot",
      "resolved": "Palautunut",
      "serverTimeLabel": "Palvelinaika",
      "env": "Ympäristö"
    },
    "auditLog": {
      "tab": "Tapahtumaloki",
      "month": "Kuukausi",
      "eventType": "Tapahtumatyyppi",
      "all": "Kaikki",
      "time": "Aika",
      "event": "Tapahtuma",
      "actor": "Tekijä",
      "target": "Kohde",
      "details": "Tiedot"
    }
  },
  "guide": {
    "title": "Sähköauton lataaminen — Kilterinlinna",
    "toc": "Sisällys",
    "intro": "Taloyhtiön autohallin latausasemat ovat Zaptec-laitteita. Lataaminen vaatii Zaptec-sovelluksen ja rekisteröidyn käyttäjätunnuksen. Tämä ohje opastaa tunnuksen luomisen, latauksen aloittamisen ja latausportaalin käytön.",
    "links": {
      "title": "Tärkeät linkit",
      "register": "Rekisteröityminen lataajaksi",
      "login": "Kirjautuminen portaaliin",
      "guide": "Ohjeet",
      "terms": "Käyttöehdot"
    },
    "contract": {
      "title": "Lataussopimuksen tekeminen",
      "step1": "Mene latausportaaliin",
      "step2": "Valitse Rekisteröidy",
      "step3": "Täytä tietosi: nimi, sähköposti, puhelinnumero, huoneistonumero ja autopaikan numero",
      "step4": "Syötä taloyhtiön rekisteröintiavain (saat sen isännöitsijältä)",
      "step5": "Vahvista sähköpostiosoitteesi syöttämällä sähköpostiisi saapuva koodi",
      "step6": "Isännöitsijä tarkistaa tietosi ja aktivoi tilisi — saat ilmoituksen sähköpostitse"
    },
    "app": {
      "title": "Zaptec-sovelluksen asentaminen",
      "intro": "Lataa Zaptec-sovellus puhelimeesi:"
    },
    "token": {
      "title": "Lataustunnisteen rekisteröinti",
      "intro": "Lataaminen vaatii tunnisteen joka rekisteröidään Zaptec-sovelluksessa. Tunnisteeksi käy:",
      "nfc": "NFC-tunnistekortti",
      "abloy": "Abloy Pulse -avain",
      "fob": "Hissirakennuksen tunnistelätkä",
      "multiple": "Voit rekisteröidä useita tunnisteita samalle käyttäjälle.",
      "stepsTitle": "Tunnisteen rekisteröinti (tehdään kerran per tunniste)",
      "step1": "Kotinäkymässä valitse Tili (Account)",
      "step2": "Valitse valikosta Zaptec-avaimet",
      "step3": "Valitse Lisää Zaptec-avain",
      "step4": "Valitse latauslaite jonka luona olet (esim. B1) — tarkista numero autopaikkasi perusteella",
      "step5": "Anna tunnisteelle kuvaava nimi (esim. \"Avainperä\" tai \"NFC-kortti\") ja paina Seuraava",
      "step6": "Lue tunniste latauslaitteen keskellä olevan lukijan kohdalla animaation mukaisesti",
      "step7": "Rekisteröinti on valmis",
      "video": "Katso video-ohje: Lataustunnisteen rekisteröinti"
    },
    "charging": {
      "title": "Lataaminen",
      "withToken": "Latauksen aloittaminen tunnisteella",
      "tokenStep1": "Kytke latauskaapeli ensin latausasemaan ja sitten ajoneuvoon",
      "tokenStep2": "Näytä latausaseman lukijalle aiemmin rekisteröity tunniste — odota kunnes kuuluu piippaus",
      "tokenStep3": "Hetken päästä latauslaitteen valon väri vaihtuu ja lataus käynnistyy",
      "withApp": "Latauksen aloittaminen sovelluksella",
      "appStep1": "Kytke latauskaapeli ensin latausasemaan ja sitten ajoneuvoon",
      "appStep2": "Avaa Zaptec-sovellus — paina Todenna",
      "appStep3": "Valitse listasta oma latausasemasi",
      "appStep4": "Kun todennus on valmis, paina OK — lataus käynnistyy",
      "appStep5": "Voit keskeyttää ja jatkaa latausta sovelluksesta painamalla Keskeytä lataus",
      "imgHome": "Aloita todennus",
      "imgChoose": "Valitse latauslaite",
      "imgConfirmed": "Todennus valmis",
      "imgStarted": "Lataus käynnissä",
      "video": "Katso video-ohje: Latauksen aloittaminen sovelluksella",
      "stopTitle": "Latauksen päättäminen",
      "stopStep1": "Irrota latauskaapeli ensin autosta ja sitten latauslaitteesta",
      "stopStep2": "Lataus päättyy myös automaattisesti kun akku on täynnä",
      "cableWarning": "Latauskaapeleiden pitäminen kiinni latauslaitteissa ilman aktiivista latausta on kiellettyä."
    },
    "cable": {
      "title": "Latauskaapeli",
      "intro": "Tarvitset oman Type-2 – Type-2 latauskaapelin (IEC 62196). Taloyhtiö ei toimita kaapelia.",
      "order": "Kytke kaapeli ensin latausasemaan, sitten ajoneuvoon",
      "lock": "Latausaseman liitäntä lukittuu automaattisesti tunnistautumisen jälkeen",
      "ce": "Käytä ainoastaan ehjää, CE-merkittyä kaapelia"
    },
    "shared": {
      "title": "Latausasemien yhteiskäyttö",
      "intro": "Latausasemat ovat kaikkien lataajien yhteiskäytössä.",
      "cableReach": "Voit käyttää mitä tahansa vapaata latausasemaa, johon oma kaapelisi yltää omalta pysäköintipaikaltasi. Autoa ei siirretä toiselle paikalle latausta varten.",
      "swapSpace": "Jos omalta pysäköintipaikaltasi ei ylety yhteenkään latausasemaan, voit pyytää paikanvaihtoa huoltoyhtiöltä (asiakaspalvelu@myyrmaenhuolto.fi). Vapaita paikkoja vaihdetaan tarvittaessa.",
      "disconnect": "Irrota kaapeli välittömästi, kun lataus on valmis tai auto on ladattu riittävästi",
      "noIdle": "Älä pidä kaapelia kytkettynä tarpeettomasti — se estää muita käyttämästä asemaa",
      "dynamic": "Latausteho (maks. 11 kW/asema) voi olla pienempi, kun useampi auto lataa samanaikaisesti — tämä on normaalia dynaamista kuormanhallintaa"
    },
    "safety": {
      "title": "Turvallisuusohjeet",
      "inspect": "Tarkasta kaapeli ennen jokaista käyttöä: vaurioitunutta kaapelia ei saa käyttää",
      "damaged": "Älä käytä latausasemaa, jos se vaikuttaa vioittuneelta — ilmoita viasta isännöitsijälle",
      "tripping": "Varmista, että kaapeli ei kulje kulkuväylille eikä muodosta kompastumisvaaraa",
      "vehicleFault": "Älä lataa autoa ilmeisen ajoneuvovian (öljyvuoto, vauriomerkki) yhteydessä",
      "tamper": "Latauslaitteita ei saa avata, muunnella tai vahingoittaa",
      "emergencyTitle": "Hätätilanteessa (savu, tuli, sähköhaju)",
      "emergency": "Irrota kaapeli jos turvallista, poistu hallista ja soita hätänumeroon 112"
    },
    "costs": {
      "title": "Kustannukset ja laskutus",
      "monthlyFee": "Latausmahdollisuuden kuukausimaksu",
      "monthlyFeeNote": "peritään autopaikan vuokran lisäksi — latausmahdollisuus ei sisälly autopaikan hintaan",
      "energyFee": "Energiamaksu",
      "energyFeeDesc": "Sähkön spot-hinta + 0,11 €/kWh marginaali",
      "billingPeriod": "Laskutusjakso",
      "billingPeriodDesc": "Jälkikäteen 3 kuukauden jaksoissa",
      "spotInfo": "Spot-hinta vaihtelee tunneittain. Lataaja on itse vastuussa voimassa olevan spot-hinnan seurannasta — esim. sahkotin.fi tai Vantaan Energian sovelluksesta.",
      "interval": "Hinta lasketaan 15 minuutin jaksoissa kunkin jakson spot-hinnan mukaan.",
      "portalTitle": "Latausportaali",
      "portalDesc": "Latausportaalissa näet lataushistoriasi ja kustannukset eriteltynä: yhteenveto, lataushistoria spot-hinta ja marginaali eriteltynä, sekä sopimustietosi. Kirjaudu portaaliin sähköpostiosoitteellasi."
    },
    "troubleshoot": {
      "title": "Ongelmatilanteet",
      "step1": "Tarkista, että tunnistautuminen (sovellus/NFC) on onnistunut",
      "step2": "Tarkista, että kaapeli on kunnolla kiinni sekä asemassa että ajoneuvossa",
      "step3": "Kokeile toista latausasemaa, jos sellainen on käytettävissä",
      "step4": "Ilmoita viasta isännöitsijälle: kerro aseman sijainti (pilarin numero) ja kuvaa vika"
    },
    "additional": {
      "title": "Lisäkäyttäjät",
      "desc": "Jos perheenjäsenesi tai muu henkilö tarvitsee latausoikeuden, voit lisätä lisäkäyttäjän latausportaalissa kohdasta Lisäkäyttäjät. Lisäkäyttäjälle luodaan oma Zaptec-tunnus, mutta hänen latauskustannuksensa laskutetaan sinulta pääkäyttäjänä."
    },
    "faq": {
      "title": "Usein kysytyt kysymykset",
      "q2": "Kuinka paljon lataus maksaa?",
      "a2": "Hinta riippuu lataushetken spot-hinnasta. Näet tarkan erittelyn latausportaalissa. Taloyhtiö lisää energian hintaan voimassa olevan hinnaston mukaisen marginaalin.",
      "q3": "Voinko ladata yöllä halvemmalla?",
      "a3": "Kyllä! Spot-hinta on tyypillisesti alhaisin yöaikaan. Voit ajastaa auton latauksen yölle ajoneuvon omista asetuksista. Sovelluksesta latauksen voi keskeyttää vaikka kaapeli on kytkettynä ja jatkaa milloin haluat.",
      "q4": "Kuka näkee lataustietoni?",
      "a4": "Sinä näet omat latauksesi latausportaalissa. Taloyhtiön isännöitsijä ja hallitus näkee kaikkien lataukset hallintanäkymässä laskutusta varten."
    },
    "contact": {
      "title": "Yhteystiedot",
      "billing": "Lataussopimus ja laskutus",
      "technical": "Tekniset ongelmat latausasemissa",
      "emergencyLabel": "Hätätilanteet",
      "terms": "Koko sopimusteksti on asiakirjassa \"Sähköajoneuvojen latauksen käyttöehdot\"."
    },
    "backToLogin": "← Takaisin kirjautumiseen"
  },
  "stage": {
    "banner": "TESTAUSYMPÄRISTÖ (STAGE) — tämä ei ole tuotantopalvelu —",
    "version": "versio:"
  }
}
